export default __webpack_public_path__ + "static/media/topMenu_search.c17ef62b.svg";